import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { getVersion, postVersion } from "./VersionService";
import { Editor } from "primereact/editor";
import { Checkbox } from "primereact/checkbox";
const ComponentLoader = React.memo(
  lazy(() => import("../../../Shared/Sidebar/ComponentLoader"))
);

function UpdateVersion() {
  const toster = useContext(TostMsg);
  const { GUID } = useParams();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const versionList = ["Mobile"];
  const [systemAlertList, setSystemAlertList] = useState([]);
  const [text, setText] = useState("");
  const history = useHistory();
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  useEffect(() => {
    GetMasterSystemAlertList('version_value', 1)
    if (GUID?.length >= 0) {
      GetVersion();
    } else {
      GetVersion();
      VersionForm.resetForm();
    }
  }, []);

  const GetVersion = async () => {
    try {
      let res = await getVersion();
      let VersionDataList = res?.Data?.filter((item) => { return item?.GUID == GUID });
      if (GUID?.length >= 0) {
        if (res?.Data[0]?.NewVersion) {
          setIsActive(true);
        } else {
          setIsActive(false);
        }
        let isValid = false;
        if (VersionDataList[0]?.IsMandatory == 1) {
          isValid = true
        } else {
          isValid = false
        }
        const editVersionDetails = {
          id: VersionDataList[0]?.Id,
          PreviousVersion: VersionDataList[0]?.PreviousVersion,
          Type: VersionDataList[0]?.Type,
          NewVersion: VersionDataList[0]?.NewVersion,
          VersionDetails: VersionDataList[0]?.VersionDetails,
          IsMandatory: isValid,
        };
        VersionForm.setValues(editVersionDetails);
      } else {
        const editVersionDetails = {
          id: 0,
          PreviousVersion: res?.Data[0]?.NewVersion,
          NewVersion: '',//res?.Data[0]?.NewVersion,
          VersionDetails: '',
          Type: 'Mobile',
          IsMandatory: '',
        };
        VersionForm.setValues(editVersionDetails);
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.VersionError);
    }
  };

  const ArticleValidation = Yup.object().shape({
    PreviousVersion: Yup.string().required("Previous version is required."),
    NewVersion: Yup.string().required("New version is required."),
    Type: Yup.string().required("Type is required."),
    VersionDetails: '',
    IsMandatory: Yup.boolean().oneOf([true], "This field must be checked."),
  });
  const VersionForm = useFormik({
    initialValues: {
      Type: "Mobile",
      PreviousVersion: "",
      NewVersion: "",
      VersionDetails: "",
      IsMandatory: "",
    },
    validationSchema: ArticleValidation,
    onSubmit: async (data) => {
      let CheckMandatory = 0;
      setLoading(true);
      if (data?.IsMandatory == true) {
        CheckMandatory = 1;
      }
      const body = {
        Id: data?.id ?? 0,
        Type: data.Type,
        PreviousVersion: data.PreviousVersion,
        NewVersion: data.NewVersion,
        VersionDetails: data.VersionDetails,
        IsMandatory: CheckMandatory,
      };

      try {
        await postVersion(body);
        setLoading(false);
        if (GUID) {
          GetMasterSystemAlertList("Version_Updated_Successfully", 0);
        } else {
          GetMasterSystemAlertList("Version_Created_Successfully", 0);
        }
        setTimeout(() => {
          history.push(`/Version`);
        }, 1000);
      } catch (err) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    },
  });

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSystemAlertList(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        // setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  return (
    <>
      <div id="circular-menu" className="circular-menu position-relation">
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link href="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <Link
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </Link>
        </div>
      </div>

      <div className="container-fluid  position-relation">

        <form onSubmit={VersionForm.handleSubmit}>
          <div className="row justify-content-center pt-4">
            <div className="col-xl-10">
              <div className="form-head display-grid align-items-center mb-4">
                <div className="me-auto">
                  <h2 className="version-h2">
                  {systemAlertList}
                  </h2>
                  <p className="version-des">
                    {systemAlertList}
                  </p>
                </div>
                <div className="rightside-tabs">
                  <button className="savebutton">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      fill="currentColor"
                      className="bi bi-check-circle me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                    </svg>
                    {GUID ? "Update" : "Save"}
                  </button>
                  <Link to="/Version" className="cancelbutton">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      fill="currentColor"
                      className="bi bi-arrow-left me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      />
                    </svg>
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-10">
              <div className="add-versionform">
                <div className="row">
                  <div className="mb-3 col-md-4">
                    <label htmlFor="Type" className="form-label-file">
                      Type<i className="inValidError">*</i>
                    </label>
                    <select
                      id="Type"
                      name="Type"
                      className={
                        "form-control wide" +
                        (VersionForm.errors.Type && VersionForm.touched.Type
                          ? " is-invalid"
                          : "")
                      }
                      onChange={VersionForm.handleChange}
                      value={VersionForm.values.Type}
                    >
                      <option value="">Choose...</option>
                      {versionList?.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                    {VersionForm.errors.Type &&
                      VersionForm.touched.Type && (
                        <div className="invalid-feedback">
                          {VersionForm.errors.Type}
                        </div>
                      )}
                  </div>
                  <div className="mb-3 col-md-4">
                    <label className="form-label-file">
                      Previous Version<i className="inValidError">*</i>
                    </label>
                    <div className="cover-form">
                      <i
                        className="fa fa-file-text-o"
                        aria-hidden="true"
                      ></i>
                      <input
                        type="number"
                        min={0}
                        max={2}
                        step="any"
                        disabled={isActive}
                        name="PreviousVersion"
                        className={
                          "form-control h-auto" +
                          (VersionForm.errors.PreviousVersion &&
                            VersionForm.touched.PreviousVersion
                            ? " is-invalid"
                            : "")
                        }
                        onChange={VersionForm.handleChange}
                        value={VersionForm.values.PreviousVersion}
                        placeholder="Previous Version"
                      ></input>
                    </div>
                    <div className="invalid-feedback">
                      {VersionForm.errors.PreviousVersion &&
                        VersionForm.touched.PreviousVersion
                        ? VersionForm.errors.PreviousVersion
                        : null}
                    </div>
                  </div>
                  <div className="mb-3 col-md-4">
                    <label className="form-label-file">
                      New Version<i className="inValidError">*</i>
                    </label>
                    <div
                      className="cover-form"
                      style={{ alignItems: "baseline" }}
                    >
                      <i
                        className="fa fa-file-text-o"
                        aria-hidden="true"
                      ></i>
                      <input
                        type="number"
                        min={0}
                        max={99}
                        step="any"
                        name="NewVersion"
                        className={
                          "form-control h-auto" +
                          (VersionForm.errors.NewVersion &&
                            VersionForm.touched.NewVersion
                            ? " is-invalid"
                            : "")
                        }
                        onChange={VersionForm.handleChange}
                        value={VersionForm.values.NewVersion}
                        placeholder="New Version"
                      ></input>
                    </div>
                    <div className="invalid-feedback">
                      {VersionForm.errors.NewVersion &&
                        VersionForm.touched.NewVersion
                        ? VersionForm.errors.NewVersion
                        : null}
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label-file">
                      Version Detail
                    </label>
                    <Editor
                      name="VersionDetails"
                      value={VersionForm.values.VersionDetails}
                      onTextChange={(e) => {
                        VersionForm.setFieldValue("VersionDetails", e.htmlValue, true); // triggers validation
                      }}
                      style={{ height: "320px" }}
                      onBlur={() => VersionForm.setFieldTouched("VersionDetails", true)}
                    />
                  </div>
                  <div className="col-md-12">
                    <Checkbox onChange={(e) => {
                      VersionForm.setFieldValue("IsMandatory", e.target.checked);
                      VersionForm.setFieldTouched("IsMandatory", true);
                    }}
                      className={
                        "form-check-input" +
                        (VersionForm.errors.IsMandatory && VersionForm.touched.IsMandatory

                        )
                      } checked={VersionForm.values.IsMandatory}></Checkbox>
                    <label
                      className="form-label-file"
                      for="IsMandatory"
                    >
                      &nbsp; Are you sure you want to make this version mandatory?
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {loading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default UpdateVersion;
